import msalInstance, { loginRequest, logoutRequest } from './index.js';

const msalPlugin = {
  install(app) {
    // Disponibilizar MSAL globalmente
    app.config.globalProperties.$msal = msalInstance;
    app.config.globalProperties.$msalLoginRequest = loginRequest;
    app.config.globalProperties.$msalLogoutRequest = logoutRequest;

    // Adicionar métodos de conveniência
    app.config.globalProperties.$loginWithMicrosoft = async function() {
      try {
        // Garantir que o MSAL está inicializado (initialize é idempotente)
        await msalInstance.initialize();

        // Redirect não retorna promise - a página é redirecionada imediatamente
        await msalInstance.loginRedirect(loginRequest);
      } catch (error) {
        // Tratar erros raros de redirect
        const swal = window.$swal || this.$swal;
        if (swal) {
          swal.fire({
            title: 'Erro no login',
            html: `Erro ao iniciar login: ${error.message || 'Erro desconhecido'}`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
        throw error;
      }
    };

    app.config.globalProperties.$logoutFromMicrosoft = async function() {
      try {
        // Garantir que o MSAL está inicializado (initialize é idempotente)
        await msalInstance.initialize();

        // Redirect não retorna promise - a página é redirecionada imediatamente
        await msalInstance.logoutRedirect(logoutRequest);
      } catch (error) {
        // Usar window.$swal como fallback se this.$swal não estiver disponível
        const swal = window.$swal || this.$swal;
        if (swal) {
          swal.fire({
            title: 'Erro no logout',
            html: `Erro no logout: ${error.message}`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
        throw error;
      }
    };

    app.config.globalProperties.$getAccessToken = async function() {
      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
          throw new Error('Nenhuma conta encontrada');
        }

        const silentRequest = {
          ...loginRequest,
          account: accounts[0],
        };

        const response = await msalInstance.acquireTokenSilent(silentRequest);
        return response.accessToken;
      } catch (error) {
        // Usar window.$swal como fallback se this.$swal não estiver disponível
        const swal = window.$swal || this.$swal;
        if (swal) {
          swal.fire({
            title: 'Erro ao obter token',
            html: `Erro ao obter token: ${error.message}`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
        throw error;
      }
    };
  },
};

export default msalPlugin;
